













import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { KSpinner } from '@kasasa/fbase-components';

import NavListTable from '@/components/NavListTable.vue';

import NService from '@/services/NavigationService';
import Nav from '@/services/Navigation';

@Component({
	components: {
		NavListTable,
		KSpinner
	}
})
export default class ListNavsPage extends Vue {
	@Prop({ default: '' }) readonly clientId!: string;
	isLoaded = false;

	navSvc = new NService(this.$store);

	navs: Nav[] = [];

	@Watch('$route', {immediate: true, deep: true})
	loadNavs() {
		this.isLoaded = false;
		this.navs = [];
		this.navSvc.findAll(this.$route.params.clientId, this.$route.params.siteId)
			.then((resp) => {
				this.navs = resp.data.data;
				this.isLoaded = true;
			});
	}

}
